import { Button, PageHeader, Typography } from 'antd';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TableArticles } from '../../components/Articles';
import { ArticlesContext } from '../../components/Articles/context/articlesContext';
import EmptyData from '../../widgets/EmptyData';

const Articles = () => {
    const { t } = useTranslation('articles', { keyPrefix: 'ARTICLES' });
    const { total } = useContext(ArticlesContext);
    const navigate = useNavigate();

    return (
        <div className="articles">
            <PageHeader
                className="site-page-header-responsive"
                title={t('TITLE')}
                footer={<TableArticles t={t} />}
                extra={total > 0 ? [
                    <Button
                        key="1"
                        type="primary"
                        onClick={() => navigate('/articles/new-article')}
                    >
                        {t('ADD_ARTICLE')}
                    </Button>,
                ] : []}
            >
                <Typography.Paragraph>
                    {t('DESCRIPTION')}
                </Typography.Paragraph>
            </PageHeader>
        </div>
    );
};

export default Articles;
